import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import YourBreedingLegacyElevated from "./sections/YourBreedingLegacyElevated";
import TheBreedersBurden from "./sections/TheBreedersBurden";
import TheConciergeSuite from "./sections/TheConciergeSuite";
import TheAnchorOurGoldStandard from "./sections/TheAnchorOurGoldStandard";
import ClientSuccessStories from "./sections/ClientSuccessStories";
import InquiryAppointments from "./sections/InquiryAppointments";
import PuppyApplicationForm from "./sections/PuppyApplicationForm";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <YourBreedingLegacyElevated />
      <TheBreedersBurden />
      <TheConciergeSuite />
      <TheAnchorOurGoldStandard />
      <ClientSuccessStories />
      <InquiryAppointments />
      <PuppyApplicationForm />
      <Footer />
    </div>;
}